import styled from "styled-components";

export const SAddNewItemModalSection = styled.div`
  padding-bottom: 24px;
`;
